import React, { useState, useEffect } from 'react';

export const TickerCounter = ({ targetNumber }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (count < targetNumber) {
                setCount((prevCount) => prevCount + Math.ceil(targetNumber / 30));
            } else {
                clearInterval(intervalId);
            }
        }, 30);

        return () => clearInterval(intervalId);
    }, [count, targetNumber]);

    return (
        <span style={{ width: String(count).length * (window.innerWidth >= 1200 ? 25 : 15) + "px", textAlign: 'right' }}>
            {count > targetNumber ? targetNumber : count}
        </span>
    );
};

